import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-4]',
    templateUrl: './roof-type-4.component.html',
    styleUrl: './roof-type-4.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType4Component {
}
